import React, { Component } from 'react'
import ScaleBarDiffBars from './ScaleBarDiffBars'
import ScaleBarDiffGraph from './ScaleBarDiffGraph'
import TableGridDiffBars from './TableGridDiffBars'
import TableGridGraph from './TableGridDiffGraph'
import PointersDiff from './PointersDiff'
import { Text, View, StyleSheet, Line, Svg } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  tableHeaderTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  tableHeaderTitleText1: {
    fontFamily: 'Inter',
    fontSize: 15,
    fontWeight: 500,
  },
  tableHeaderTitleText2: {
    fontFamily: 'Inter',
    fontSize: 12,
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    borderBottom: '1 solid rgb(226 232 240)',
  },
  tableFirstCol: {
    width: '50%',
    backgroundColor: '#ffffff',
  },
  tableFirstColAnswer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  tableFirstColAnswerText: {
    display: 'flex',
    flexDirection: 'row',
    width: '80%',
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
  },
  tableFirstColAnswerPoints: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '10%',
    height: '100%',
    textAlign: 'right',
    justifyContent: 'flex-end',
    paddingLeft: 3,
    paddingRight: 10,
  },
  tableLastCol: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgb(226 232 240)',
    borderBottom: '1 solid #fff',
    paddingRight: 7,
    opacity: 0.7,
    position: 'relative',
  },
  tableLastColRows: {
    width: '100%',
    flexDirection: 'row',
    height: 15,
  },
  scaleBarContainer: {
    position: 'relative',
    zIndex: 50,
    display: 'flex',
    flexDirection: 'row',
  },
  gridContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '5.5%',
    top: -1,
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1 solid rgb(226 232 240)',
  },
  legendContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '5%',
    paddingRight: '5%',
    marginTop: 25,
  },
  legendText: {
    fontFamily: 'Inter',
    fontSize: 8,
    fontWeight: 400,
  },
  legendLine: {
    height: 1.5,
    width: 5,
    backgroundColor: '#000',
  },
  legendDot: {
    height: 5,
    width: 5,
    backgroundColor: '#000',
    borderRadius: 20,
  }
});


const OverviewDifference = ({ coverData, categoriesData, uiData }) => {

  return (
    <>
      <View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            width: '100%',
            paddingLeft: '5%',
            paddingRight: '5%',
            backgroundColor: "rgba(189,187,183,0.25)",
          }}
        >
          <View style={styles.tableHeaderTitle}>
            <Text style={styles.tableHeaderTitleText1}>{uiData.header01}</Text>
          </View>

        </View>
      </View>

      <View
        style={{
          position: 'relative',
          paddingLeft: '5%',
          paddingRight: '5%',
          marginTop: 50,
          marginBottom: 50,
          width: '100%',
        }}
      >
        <View style={styles.gridContainer} zIndex={9999}>
          <View style={{ width: '50%' }}></View>
          <View style={{ width: '50%' }}>
            <TableGridDiffBars />
          </View>
        </View>
        {categoriesData.map(entry => {

          const barWidth = ((Math.abs(entry.points[0] - entry.points[1]) / 30 * 100) + (entry.points[0] - entry.points[1] !== 0 ? 0.5 : 0)) + '%'

          return (
            <View key={entry}>
              <View style={styles.tableContainer}>
                <View style={styles.tableFirstCol}>
                  <View style={styles.tableFirstColAnswer}>
                    <View style={styles.tableFirstColAnswerText}>
                      <Text
                        style={{
                          fontFamily: 'Inter',
                          fontSize: 10,
                          fontWeight: 500,
                          lineHeight: 1.2,
                        }}
                      >
                        {entry.name}
                      </Text>
                    </View>
                    <View style={styles.tableFirstColAnswerPoints}>
                      <Text
                        style={{
                          fontFamily: 'Inter',
                          fontSize: 10,
                          fontWeight: 700,
                          textAlign: 'right',
                          color: entry.points[0] - entry.points[1] > 0 ? '#7bb662' : (entry.points[0] - entry.points[1] < 0 ? '#dc2626' : '#000'),
                        }}
                      >
                        {entry.points[0] - entry.points[1]}
                      </Text>
                    </View>
                  </View>
                </View>

                <View style={styles.tableLastCol}>
                  <View style={styles.tableLastColRows}>
                    <View
                      style={{
                        height: 15,
                        position: 'absolute',
                        borderTopRightRadius: (entry.points[0] - entry.points[1] >= 0) ? 5 : 0,
                        borderBottomRightRadius: (entry.points[0] - entry.points[1] >= 0) ? 5 : 0,
                        borderTopLeftRadius: (entry.points[0] - entry.points[1] < 0) ? 5 : 0,
                        borderBottomLeftRadius: (entry.points[0] - entry.points[1] < 0) ? 5 : 0,
                        width: barWidth,
                        backgroundColor: (entry.points[0] - entry.points[1] >= 0) ? "#7bb662" : "#dc2626",
                        ...(entry.points[0] - entry.points[1] >= 0 ? { left: '33.8%' } : { right: '66.2%' })
                      }}
                    >
                    </View>
                  </View>
                </View>

              </View>
            </View>
          );
        }
        )}
        <View style={styles.scaleBarContainer}>
          <View style={{ width: '50%' }}></View>
          <View style={{ width: '50%', marginBottom: 10 }}>
            <ScaleBarDiffBars />
          </View>
        </View>
      </View>

      <View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            width: '100%',
            paddingLeft: '5%',
            paddingRight: '5%',
            backgroundColor: "rgba(189,187,183,0.25)",
          }}
        >
          <View style={styles.tableHeaderTitle}>
            <Text style={styles.tableHeaderTitleText1}>{uiData.header02}</Text>
          </View>

        </View>
      </View>

      <View style={styles.legendContainer}>
        <View style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <View style={styles.legendLine}></View>
            <View style={styles.legendDot}></View>
            <View style={[styles.legendLine, { marginRight: 5 }]}></View>
          </View>
          <Text style={[styles.legendText, { marginRight: 10 }]}>{coverData.profile[0]}</Text>
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <View style={[styles.legendLine, { backgroundColor: '#3395E0' }]}></View>
            <View style={[styles.legendDot, { backgroundColor: '#3395E0' }]}></View>
            <View style={[styles.legendLine, { marginRight: 5, backgroundColor: '#3395E0' }]}></View>
          </View>
          <Text style={styles.legendText}>{coverData.profile[1]}</Text>
        </View>
      </View>

      <View
        style={{
          position: 'relative',
          paddingLeft: '5%',
          paddingRight: '5%',
          marginTop: 25,
          width: '100%',
        }}
      >
        <View style={styles.gridContainer} zIndex={9999}>
          <View style={{ width: '50%' }}></View>
          <View style={{ width: '50%' }}>
            <PointersDiff uiData={uiData} />
            <TableGridGraph />
          </View>
        </View>

        {categoriesData.map((entry, index) => {
          const currentDotXPosition1 = entry.points[1] !== undefined ? ((entry.points[1] + 17) / 5) * 10 : 0;
          const nextEntry = categoriesData[index + 1];
          let nextDotXPosition1 = 0;
          if (nextEntry) {
            nextDotXPosition1 = nextEntry.points[1] !== undefined ? ((nextEntry.points[1] + 17) / 5) * 10 : 0;
          }

          return (
            <View key={entry.name}>
              <View style={styles.tableContainer}>
                <View style={styles.tableFirstCol}>
                  <View style={styles.tableFirstColAnswer}>
                    <View style={styles.tableFirstColAnswerText}>
                      <Text style={{
                        fontFamily: 'Inter',
                        fontSize: 10,
                        fontWeight: 500,
                        lineHeight: 1.2,
                      }}>
                        {entry.name}
                      </Text>
                    </View>
                  </View>
                </View>

                <View style={[styles.tableLastCol, { backgroundColor: 'transparent', opacity: 1, borderBottom: 'none' }]}>
                  <View style={styles.tableLastColRows}>
                    {entry.points[1] !== undefined && (
                      <View style={{
                        height: 5,
                        width: 5,
                        backgroundColor: '#000',
                        borderRadius: 20,
                        position: 'absolute',
                        left: currentDotXPosition1,
                        top: 5,
                      }}></View>
                    )}
                    {nextEntry && entry.points[1] !== undefined && nextEntry.points[1] !== undefined && (
                      <Svg height='35' width='100%'>
                        <Line
                          x1={currentDotXPosition1 + 2.5}
                          y1={7.5}
                          x2={nextDotXPosition1 + 2}
                          y2={30}
                          strokeWidth={1.5}
                          stroke='#000'
                        />
                      </Svg>
                    )}
                  </View>
                </View>
              </View>
            </View>
          );
        })}

        <View style={{
          position: 'absolute',
          left: '5.5%',
          backgroundColor: 'transparent',
          opacity: 0,
          marginTop: -1,
        }}>

          {categoriesData.map((entry, index) => {

            const currentDotXPosition = ((entry.points[0] + 17) / 5) * 10;
            const nextEntry = categoriesData[index + 1];
            let nextDotXPosition = 0;
            if (nextEntry) {
              nextDotXPosition = ((nextEntry.points[0] + 17) / 5) * 10;
            }

            return (
              <View key={entry.name} style={{
                paddingTop: 4,
                paddingBottom: 4,
              }}>
                <View style={[styles.tableContainer, { border: 'none', backgroundColor: 'transparent' }]}>
                  <View style={styles.tableFirstCol}>
                  </View>

                  <View style={[styles.tableLastCol, { backgroundColor: 'transparent', opacity: 1, borderBottom: 'none' }]}>
                    <View style={styles.tableLastColRows}>
                      {entry.points[0] !== undefined && (
                        <View style={{
                          height: 5,
                          width: 5,
                          backgroundColor: '#3395E0',
                          borderRadius: 20,
                          position: 'absolute',
                          left: currentDotXPosition,
                          top: 5,
                        }}></View>
                      )}
                      {nextEntry && (
                        <Svg height='35' width='100%'>
                          <Line
                            x1={currentDotXPosition + 2.5}
                            y1={7.5}
                            x2={nextDotXPosition + 2}
                            y2={30}
                            strokeWidth={1.5}
                            stroke='#3395E0'
                          />
                        </Svg>
                      )}
                    </View>
                  </View>
                </View>
              </View>
            );
          })}
        </View>

        <View style={styles.scaleBarContainer}>
          <View style={{ width: '50%' }}></View>
          <View style={{ width: '50%', marginBottom: 10 }}>
            <ScaleBarDiffGraph />
          </View>
        </View>
      </View>
    </>
  )
};

export default OverviewDifference;
